import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import sxStyles from "./ErrorPage.style";
const ErrorPage = ({ title, subtitle, icon = null, error, children }) => {
    const errorElement = useMemo(() => {
        if (process.env.NODE_ENV !== "production" && error) {
            return (React.createElement(Typography, { variant: "caption", color: "error", align: "left", sx: { mt: 2, overflow: "auto" } },
                React.createElement("pre", { color: "red" }, error.stack)));
        }
        return null;
    }, [error]);
    return (React.createElement(Stack, { flex: 1, justifyContent: "center", alignItems: "center" },
        React.createElement(Paper, { sx: (theme) => sxStyles(theme).paper },
            icon && (React.createElement(Box, { sx: (theme) => sxStyles(theme).icon },
                React.createElement(SvgIcon, { fontSize: "inherit" }, icon))),
            title && (React.createElement(Typography, { sx: (theme) => sxStyles(theme).title, color: "primary" }, title)),
            subtitle && (React.createElement(Typography, { sx: (theme) => sxStyles(theme).subtitle, color: "primary" }, subtitle)),
            children ? (React.createElement(Box, { mt: 2 },
                children,
                errorElement)) : (errorElement))));
};
export default ErrorPage;
//# sourceMappingURL=ErrorPage.js.map